/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  var isProcessing = false;

  function getConfig() {
    var el = document.getElementById('FreeGiftConfig');
    if (!el) return null;
    var ids = (el.getAttribute('data-qualifying-product-ids') || '')
      .split(',')
      .map(function (id) { return parseInt(id, 10); })
      .filter(function (id) { return !isNaN(id); });
    return {
      variantId: parseInt(el.getAttribute('data-gift-variant-id'), 10),
      minQty: parseInt(el.getAttribute('data-min-qualifying-qty'), 10) || 2,
      productIds: ids,
      startsAt: Date.parse(el.getAttribute('data-starts-at') || '') || 0
    };
  }

  function evaluateGift() {
    if (isProcessing) return;
    var config = getConfig();
    if (!config || !config.variantId) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var giftLine = null;
        var qualifyingQty = 0;

        cart.items.forEach(function (item) {
          var isGift = item.properties && item.properties['_free_gift'] === 'true';
          if (isGift) {
            giftLine = item;
          } else if (config.productIds.indexOf(item.product_id) !== -1) {
            qualifyingQty += item.quantity;
          }
        });

        var isLive = Date.now() >= config.startsAt;
        var qualifies = isLive && qualifyingQty >= config.minQty;

        if (qualifies && !giftLine) {
          addGift(config.variantId);
        } else if (!qualifies && giftLine) {
          removeGift(giftLine.key);
        }
      })
      .catch(function (err) {
        console.error('Free gift check failed:', err);
      });
  }

  function addGift(variantId) {
    isProcessing = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { '_free_gift': 'true' } }]
      })
    })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('Failed to add free gift:', err);
      })
      .finally(function () {
        isProcessing = false;
      });
  }

  function removeGift(lineKey) {
    isProcessing = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('Failed to remove free gift:', err);
      })
      .finally(function () {
        isProcessing = false;
      });
  }

  document.addEventListener('theme:cart:change', evaluateGift);
  document.addEventListener('DOMContentLoaded', evaluateGift);
})();


(function () {
  function updateFreeGiftProgress() {
    var giftBars = document.querySelectorAll('[data-free-gift]');
    if (!giftBars.length) return;

    var cartItems = document.querySelector('cart-items');
    var subtotal = cartItems ? cartItems.subtotal : 0;

    giftBars.forEach(function (bar) {
      var limit = parseFloat(bar.getAttribute('data-free-gift-limit')) * 100;
      if (!limit) return;

      var remaining = Math.max(limit - subtotal, 0);
      var isQualified = subtotal >= limit;

      var leftToSpendEl = bar.querySelector('[data-left-to-spend]');
      if (leftToSpendEl && window.theme && window.theme.formatMoney) {
        leftToSpendEl.innerHTML = window.theme
          .formatMoney(remaining, window.theme.moneyFormat)
          .replace('.00', '');
      }

      bar.classList.toggle('is-success', isQualified);
    });
  }

  document.addEventListener('theme:cart:change', updateFreeGiftProgress);
  document.addEventListener('DOMContentLoaded', updateFreeGiftProgress);
})();
